import { Auth0Provider } from "@auth0/auth0-react";
import { useConfigContext } from "@/contexts";

export function Auth0ProviderWithConfig({ children }) {
  const { auth0 } = useConfigContext();
  console.log("auth0", auth0);
  return (
    <Auth0Provider
      domain={auth0.domain}
      clientId={auth0.clientId}
      audience={auth0.audience}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: auth0.audience,
        scope: "openid profile email create:farms",
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
}
